<template>
  <div class="hpsfir-card member">
    <el-tabs v-model="activeTab" class="member-tabs">
      <el-tab-pane label="会员列表" name="memberList">
        <MemberList v-if="activeTab === 'memberList'" />
      </el-tab-pane>
      <el-tab-pane label="会员等级规则" name="levelRule">
        <LevelRule v-if="activeTab === 'levelRule'" />
      </el-tab-pane>
      <el-tab-pane label="会员权益列表" name="benefitList">
        <BenefitList v-if="activeTab === 'benefitList'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import MemberList from './memberlist/index.vue';
import LevelRule from './levelrule/index.vue';
import BenefitList from './benefitlist/index.vue';

const activeTab = ref('memberList');
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
